import { Note } from './src/Note.ts';
customElements.define('dockit-note', Note);
